//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.EntityPropTableBuilder.js";
let d=[[],[],[]];
SPLM.Motion.HydrodynamicBearingBuilder = class extends SPLM.Motion.EntityPropTableBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.HydrodynamicBearingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.HydrodynamicBearingBuilder.CavitationAlgorithm = Object.freeze({
    "QuasiStatic" : "QuasiStatic", "MassConserving" : "MassConserving", "UpdateMassConserving" : "UpdateMassConserving"});

SPLM.Motion.HydrodynamicBearingBuilder.Length = Object.freeze({
    "Millimeter" : "Millimeter", "Centimeter" : "Centimeter", "Meter" : "Meter", "Inch" : "Inch", "Feet" : "Feet"});

SPLM.Motion.HydrodynamicBearingBuilder.Force = Object.freeze({
    "Newton" : "Newton", "Micronewton" : "Micronewton", "KilogramForce" : "KilogramForce", "Pound" : "Pound", "Dyne" : "Dyne"});

SPLM.Motion.HydrodynamicBearingBuilder.Mass = Object.freeze({
    "Gram" : "Gram", "Kilogram" : "Kilogram", "MetricTonne" : "MetricTonne", "Slinch" : "Slinch", "Slug" : "Slug"});

SPLM.Motion.HydrodynamicBearingBuilder.ViscosityType = Object.freeze({
    "Expression" : "Expression", "Profile2D" : "Profile2D", "TemperatureDependent" : "TemperatureDependent"});

SPLM.Motion.HydrodynamicBearingBuilder.Lubricant = Object.freeze({
    "Predefined" : "Predefined", "Profile2D" : "Profile2D"});

SPLM.Motion.HydrodynamicBearingBuilder.LubricantType = Object.freeze({
    "Sae5w30" : "Sae5w30", "Sae10w30" : "Sae10w30", "Sae10w40" : "Sae10w40", "Sae15w40" : "Sae15w40", "Sae20w50" : "Sae20w50", "Sae10w" : "Sae10w", "Sae20w" : "Sae20w", "Sae20" : "Sae20", "Sae30" : "Sae30", "Sae40" : "Sae40", "Sae50" : "Sae50"});

export default SPLM;